/* hej-uitleg — het gedrag van sections/hej-uitleg.liquid.
 *
 * Opzet zoals assets/faq-apple.js en assets/hej-tips.js: een knop met aria-expanded en een klasse
 * is-open op het vak eronder. Eén verschil, en dat is met opzet: de hoogte wordt hier door dit
 * script in echte pixels gezet in plaats van door de opmaak van 0 naar auto te laten lopen.
 *
 * Waarom: beeld voor beeld gemeten op de live pagina bleef het opengaan met height 0 naar auto de
 * eerste tiende seconde vlak liggen (14ms 0px, 98ms 3px, en daarna pas echt), terwijl dichtgaan
 * vanaf het eerste beeld liep. Een andere curve veranderde daar niets aan, dus het zat niet in de
 * versnelling maar in het uitrekenen van die auto-hoogte. Met twee echte getallen als begin- en
 * eindpunt heeft de browser niets uit te rekenen en begint de beweging direct.
 *
 * Dat heeft nog een voordeel: zo is interpolate-size niet meer nodig en beweegt het ook in
 * browsers die dat nog niet kennen.
 *
 * Na het opengaan gaat de hoogte op auto. Anders zou een kaart zijn oude pixelhoogte houden als
 * het venster smaller wordt en de tekst meer regels nodig heeft.
 *
 * Er staat nooit meer dan één vraag open, en een open vraag kan weer dicht.
 *
 * De sectie wordt via het scripttag zelf opgezocht en niet via een opzoeking over de hele pagina,
 * zodat de sectie twee keer op een pagina kan staan zonder dat de tweede de eerste bedient.
 */
var __uitlegZelf = document.currentScript;
var __uitlegWortel = __uitlegZelf ? __uitlegZelf.parentElement : null;

(function () {
  var sectie = (__uitlegWortel && __uitlegWortel.querySelector('.hej-uitleg'))
    || document.querySelector('.hej-uitleg:not([data-uitleg-gereed])');
  if (!sectie || sectie.hasAttribute('data-uitleg-gereed')) return;
  sectie.setAttribute('data-uitleg-gereed', '');

  var items = sectie.querySelectorAll('.hej-uitleg__item');
  if (!items.length) return;

  function deel(item, wat) { return item.querySelector('.hej-uitleg__' + wat); }

  function openen(item) {
    var knop = deel(item, 'knop');
    var vak = deel(item, 'uit');
    if (!knop || !vak) return;
    knop.setAttribute('aria-expanded', 'true');
    vak.classList.add('is-open');
    vak.style.height = vak.scrollHeight + 'px';
  }

  function sluiten(item) {
    var knop = deel(item, 'knop');
    var vak = deel(item, 'uit');
    if (!knop || !vak) return;
    if (knop.getAttribute('aria-expanded') !== 'true') return;
    /* Van auto naar een getal, dan een herberekening forceren, en dan naar nul. Zonder die
       tussenstap heeft de browser geen beginwaarde om vanaf te lopen en klapt het dicht. */
    vak.style.height = vak.scrollHeight + 'px';
    void vak.offsetHeight;
    knop.setAttribute('aria-expanded', 'false');
    vak.classList.remove('is-open');
    vak.style.height = '0px';
  }

  Array.prototype.forEach.call(items, function (item) {
    var knop = deel(item, 'knop');
    var vak = deel(item, 'uit');
    if (!knop || !vak) return;
    var raakStartY = 0;

    /* Zodra het opengaan klaar is mag de hoogte weer los, zodat de kaart meegroeit als de tekst
       op een smaller venster meer regels nodig heeft. */
    vak.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'height') return;
      if (vak.classList.contains('is-open')) vak.style.height = 'auto';
    });

    function wissel(e) {
      e.preventDefault();
      var staatOpen = knop.getAttribute('aria-expanded') === 'true';
      Array.prototype.forEach.call(items, function (ander) { sluiten(ander); });
      if (!staatOpen) openen(item);
    }

    knop.addEventListener('click', wissel);
    knop.addEventListener('touchstart', function (e) {
      raakStartY = e.touches[0].clientY;
    }, { passive: true });
    knop.addEventListener('touchend', function (e) {
      /* Bij scrollen mag een aanraking de kaart niet openen. */
      if (Math.abs(e.changedTouches[0].clientY - raakStartY) > 8) return;
      e.preventDefault();
      wissel(e);
    }, { passive: false });
  });
})();
